/** Public client env helpers. Secrets must never use VITE_. */

const placeholder = (value: string | undefined, name: string): string => {
  if (value && !value.includes('YOUR_')) return value;
  // Allow builds/typechecks with placeholders; runtime UI shows a banner.
  return value || `PLACEHOLDER_${name}`;
};

export const publicEnv = {
  supabaseUrl: placeholder(import.meta.env.VITE_SUPABASE_URL, 'SUPABASE_URL'),
  supabaseAnonKey: placeholder(
    import.meta.env.VITE_SUPABASE_ANON_KEY,
    'SUPABASE_ANON_KEY',
  ),
  appName: import.meta.env.VITE_APP_NAME || 'Dome Events & Conferencing',
  appUrl:
    import.meta.env.VITE_PUBLIC_APP_URL || 'https://events.thedomenamibia.com',
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
};

export function hasRealSupabaseConfig(): boolean {
  const { supabaseUrl, supabaseAnonKey } = publicEnv;
  return (
    supabaseUrl.startsWith('https://') &&
    !supabaseUrl.includes('YOUR_') &&
    !supabaseUrl.includes('PLACEHOLDER_') &&
    Boolean(supabaseAnonKey) &&
    !supabaseAnonKey.includes('YOUR_') &&
    !supabaseAnonKey.includes('PLACEHOLDER_')
  );
}
